import { render, staticRenderFns } from "./OrganizationButton.vue?vue&type=template&id=a43874e4&"
import script from "./OrganizationButton.vue?vue&type=script&lang=js&"
export * from "./OrganizationButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports